module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAAAQCAIAAABvH4+RAAAACXBIWXMAAC4jAAAuIwF4pT92AAABCElEQVRo3u3ZPW6GMAwG4MRhQgrcAk7CxpGZOQI/4hJBYUzsDkifunQjrUzf5wAm2G+CFIwBAACAN7MFS1trrdXTih+JiIg8W5OI3hGgEs0BUKbIOWetFZG2bbuuSynpPU1FpKqqEMJxHM9W7vvee59zVv2pIaJ932OM98Q1Ld05Z4wZx1FEUkqi1r34aZrMc1/nu848z9qbk3MWkWEYPhMvtRP0bmL4J5BRQEYBkFFARgH+UlX6Acys93qFmZ1zzFyi8guaQ0S/cOVUPKNEpPefyj2AEhcrd09UN+f7i2jNaAhhWZYYo94xMLP3ftu2T16fyv26rk3TXNelujl1XZ/n+WBzAFT6AgqL8jc30XLwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/wentylator.png
// module id = 328E
// module chunks = 1